module.exports = {
  template: require('./countries-list-container.pug')()
  controller: require('./countries-list-container.ctrl')
}
